module.exports = "<div class=\"m-scene-list\" v-if=\"isRender\">\r\n    <div class=\"container\">\r\n        <div class=\"block-title\">\r\n            <i class=\"u-icon u-icon-collocation\"></i>\r\n        </div>\r\n        <div>\r\n            <div class=\"image-item\" v-for=\"o in scenes\">\r\n                <img v-lazy=\"fnjiImage(o.image)\" :key=\"o.image\" :width=\"getImageWidth(o.type)\">\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!./product-detail/component/scene-list.html
// module id = 331
// module chunks = 0